export default __webpack_public_path__ + "static/media/focus3big.c2cdf2e3.jpg";